import {FormPost} from "../util";
import APP from "../appConfig";

const filedownloadUrl = "fileupload/";
const filedownload = "filedownload/";
const filedownloadViaToken = filedownload + "token/";
// filedownload
// const APP = window.appUrl

const url = {
    invoices: `${filedownloadUrl}invoices`, //
};

// fileupload/invoices
const fileuploadApi = {
    // 获取pdf url
    getPdfUrl: (id) => {
        return APP.DOMAIN + filedownload + id;
    },
    getPdfViaTokenUrl: (id, token) => {
        return APP.DOMAIN + filedownloadViaToken + id + "?token=" + token;
    },
    uploadInvoices: (params = {}) => {
        return FormPost(url.invoices, params);
    },
};
export {
    fileuploadApi
};